import { render, staticRenderFns } from "./RequestManage.vue?vue&type=template&id=55ff967e&"
import script from "./RequestManage.vue?vue&type=script&lang=js&"
export * from "./RequestManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports